import { render, staticRenderFns } from "./PopularProfessionsModule.vue?vue&type=template&id=2ba7cd92"
import script from "./PopularProfessionsModule.vue?vue&type=script&lang=js"
export * from "./PopularProfessionsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports